import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";

import { NWDMaintenanceBanner } from "../../../../../helpers/types";

@Component({
  selector: "maintenance-banner",
  templateUrl: "maintenance-banner.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./maintenance-banner.scss"],
})
export class MaintenanceBannerComponent {
  protected maintenanceBanner = input.required<NWDMaintenanceBanner>();

  protected title = computed(() => this.maintenanceBanner().title);
  protected contents = computed(() => this.maintenanceBanner().contents);
}
